import { useHistory, Route } from 'react-router-dom';
import { Button, Card, Page, Typography } from 'seagull';
import { routes } from "../../constants";
import { useFeatureFlags } from "../../hooks/useFeatureFlags";
import { ProposalsReport } from "./ProposalsReport/ProposalsReport";
import { useSetDocumentTitle } from "../../hooks/useSetDocumentTitle";
import { ActiveServicesReport } from "./ActiveServices/ActiveServices";
import { FutureInvoicesReport } from "./FutureInvoices/FutureInvoices";
import { RemainingCreditReport } from "./RemainingCredit/RemainingCredit";
import { RevenueBreakdownReport } from "./RevenueBreakdown/RevenueBreakdown";
import styles from "./Reports.module.scss";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const ReportCard = props => {
  const {
    title,
    description,
    url,
    testId
  } = props;
  const history = useHistory();
  return /*#__PURE__*/_jsxs(Card, {
    className: styles.reportCard,
    autoHeight: true,
    children: [/*#__PURE__*/_jsxs("div", {
      className: styles.reportCardDetails,
      children: [/*#__PURE__*/_jsx(Typography, {
        variant: "h6",
        weight: "bold",
        children: title
      }), /*#__PURE__*/_jsx(Typography, {
        variant: "paragraph1",
        children: description
      })]
    }), /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsx(Button, {
        "data-testid": "report-card-".concat(testId, "-navigate"),
        onClick: () => history.push(routes.reports + url),
        children: "Go to report"
      })
    })]
  });
};
const AllReports = () => {
  useSetDocumentTitle('Reports');
  const {
    PROPOSALS_REPORT
  } = useFeatureFlags();
  return /*#__PURE__*/_jsxs(Page, {
    header: "All Reports",
    "data-testid": "all-reports-screen",
    children: [/*#__PURE__*/_jsx(ReportCard, {
      title: "Revenue Breakdown",
      description: "Review historical revenue with detailed breakdowns across various time intervals. This revenue data is based on paid invoices and accounts for any refunds and disputes, if applicable. Note that the revenue data does not include any platform fees.",
      url: "/revenue",
      testId: "revenue"
    }), /*#__PURE__*/_jsx(ReportCard, {
      title: "Active Services",
      description: "View all active services across all of your agreements with options to apply various filters.",
      url: "/active-services",
      testId: "active-services"
    }), /*#__PURE__*/_jsx(ReportCard, {
      title: "Future Invoices",
      description: "View all invoices scheduled for issuance over the next 12 months.",
      url: "/future-invoices",
      testId: "future-invoices"
    }), PROPOSALS_REPORT && /*#__PURE__*/_jsx(ReportCard, {
      title: "Sent Proposals",
      description: "View all sent proposals by their sent date and current status.",
      url: "/sent-proposals",
      testId: "sent-proposals"
    }), /*#__PURE__*/_jsx(ReportCard, {
      title: "Remaining Credit",
      description: "View the remaining credit your clients have per agreement.",
      url: "/remaining-credit",
      testId: "remaining-credit"
    })]
  });
};
export const Reports = _ref => {
  let {
    now = new Date()
  } = _ref;
  const {
    PROPOSALS_REPORT
  } = useFeatureFlags();
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Route, {
      path: routes.reports,
      exact: true,
      render: () => /*#__PURE__*/_jsx(AllReports, {})
    }, "all-reports"), /*#__PURE__*/_jsx(Route, {
      path: routes.revenueReport,
      exact: true,
      render: () => /*#__PURE__*/_jsx(RevenueBreakdownReport, {
        now: now
      })
    }, "revenue-report"), /*#__PURE__*/_jsx(Route, {
      path: routes.activeServicesReport,
      exact: true,
      render: () => /*#__PURE__*/_jsx(ActiveServicesReport, {})
    }, "active-services-report"), /*#__PURE__*/_jsx(Route, {
      path: routes.futureInvoicesReport,
      exact: true,
      render: () => /*#__PURE__*/_jsx(FutureInvoicesReport, {})
    }, "future-invoices-report"), PROPOSALS_REPORT && /*#__PURE__*/_jsx(Route, {
      path: routes.proposalsReport,
      exact: true,
      render: () => /*#__PURE__*/_jsx(ProposalsReport, {
        now: now
      })
    }, "proposals-report"), /*#__PURE__*/_jsx(Route, {
      path: routes.remainingCreditReport,
      exact: true,
      render: () => /*#__PURE__*/_jsx(RemainingCreditReport, {})
    }, "remaining-credit-report")]
  });
};